import RpcService from "@/core/services/Rpc/RpcService";

/**
 * DAO для работы с отчётами
 * Только RPC-вызовы, без гидрации и бизнес-логики
 */
class ReportsDAO {

	/**
	 * Запрашивает у бэкенда сгенерированный отчёт по указанному RPC-методу
	 * Используется legacy-формат, т.к. контроллер возвращает массив { file: ... }
	 */
	static async getReport(rpcMethod: string): Promise<{ data: any; meta: any }> {
		return await RpcService.makeLegacyRequest(rpcMethod);
	}
}

export default ReportsDAO;
